import { LoggingLevel } from '@h5s/util-logger';
import { AuthConfig } from 'angular-oauth2-oidc';
import { APP_VERSION } from './version';

const ENVIRONMENT_NAME = 'sandbox';

const FRONTEND_URL = `https://${FRONTEND_DOMAIN}`;
const BACKEND_URL = `https://${BACKEND_DOMAIN}`;
const Z_PRINTER_GATEWAY_URL = 'https://zbridge.local:23100';
const IDENTITY_PROVIDER_URL = 'https://app.zidentity.cloud/';

/**
 * Path base del bundle servito: '/it/', '/en/', ... nei bundle localizzati, dove Angular
 * riscrive il <base href>. È costante per bundle e NON dipende dalla rotta di ingresso:
 * per questo il redirect URI che ne deriva è registrabile in exact-match sull'Identity Provider.
 */
const APP_BASE_PATH = new URL(document.baseURI).pathname;

const authConfig: AuthConfig = {
  // URL dell'Identity Provider
  issuer: IDENTITY_PROVIDER_URL,

  // URI dell'app per il redirect dopo il login (deve essere registrato su ZIdentity)
  redirectUri: `${FRONTEND_URL}${APP_BASE_PATH}`,

  // URI di redirect dopo il logout (deve essere registrato su ZIdentity)
  postLogoutRedirectUri: FRONTEND_URL,

  // L'id della SPA. La SPA è registrata con questo id presso l'Identity Provider
  clientId: 'v2pfRBMycu3vo74Wjhhy8Rx63bsyTic65hBg8wMQNplhb73vCNH1qnb0A84iEOKk',

  responseType: 'code',

  // Imposta lo scope per i permessi che il client dovrebbe richiedere
  // I primi quattro sono definiti da OIDC.
  // Importante: richiedere offline_access per ottenere un refresh token
  scope: 'openid profile email offline_access zstay-sandbox:zstay',

  // Richiede HTTPS
  requireHttps: true,
  // Controlla che tutti gli endpoint del discovery document inizino con l’issuer
  strictDiscoveryDocumentValidation: true,
  // Rimuove il # dalla URL dopo login
  clearHashAfterLogin: true,
  // Logga debug in console
  showDebugInformation: true,
  // Blocca richieste silent refresh da altre origini
  checkOrigin: true,
};

export const environment = {
  production: false,
  environment: ENVIRONMENT_NAME,
  apiConfig: {
    graphqlUrl: `${BACKEND_URL}/graphql`,
    restUrl: `${BACKEND_URL}/api`,
    uasUrl: `${BACKEND_URL}/uas`,
    systemUrl: `${BACKEND_URL}/system`,
    zPrinterGatewayBaseUrl: Z_PRINTER_GATEWAY_URL,
    zPrinterGatewayUrl: `${Z_PRINTER_GATEWAY_URL}/api/printer`,
  },
  authConfig,
  toastConfig: {
    duration: 3000,
  },
  rollbarConfig: {
    enabled: false,
    accessToken: 'f19770c80b2049019aa75ca1079ac837',
    captureUncaught: false,
    captureUnhandledRejections: false,
    captureIp: true,
    environment: ENVIRONMENT_NAME,
    payload: {
      environment: ENVIRONMENT_NAME,
      client: {
        javascript: {
          code_version: APP_VERSION,
          source_map_enabled: true,
          guess_uncaught_frames: true,
        },
      },
    },
  },
  loggingConfig: {
    loggingLevel: LoggingLevel.DEBUG,
    externalLoggingLevel: LoggingLevel.NONE,
  },
  translationConfig: {
    redirectOnLanguageChange: true,
    translationsPath: 'i18n/dynamic/',
  },
};
